import { utils, directives } from './index';
import components from './src/components/mobile';
export default {
    utils,
    directives,
    components
};
